//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'PowerOffConfirmation',
  computed: {
    ...mapGetters({
      restartNow: 'authentication/getRestartValue',
      shutdownNow: 'authentication/getShutdownValue',
      downloadInProgress: 'getDownloadInProgress',
    }),
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    shutdown() {
      this.$store.dispatch('authentication/shutdown').then(() => {
        this.$router.push('/shutdown');
      });
    },
    restart() {
      this.$store.dispatch('authentication/restart').then(() => {
        this.$router.push('/restart');
      });
    },
    cancelShutdown() {
      this.$emit('close-dialog', false);
    },
  },
  props: {
    openDialog: Boolean,
  },
  watch: {
    openDialog(newVal) {
      this.dialog = newVal;
    },
    restartNow(newVal) {
      if (newVal === true) {
        this.$emit('close-dialog', false);
        this.$router.push('/restart');
      }
    },
    shutdownNow(newVal) {
      if (newVal === true) {
        this.$emit('close-dialog', false);
        this.$router.push('/shutdown');
      }
    },
  },
};
